// 备用wechatId，用于路径不传参时使用
const importFn = require.context('./env/', false, /\.js$/)
const env = process.env.NODE_Label
const currentEnv = process.env.VUE_APP_ENV

function install() {
  let result = {}
  importFn.keys().forEach(path => {
    const component = importFn(path).default
    const fileName = path.replace(/(.\/)|(.env.js)/gi,'')
    if (fileName == env) result = component
  })
  console.log(result[currentEnv] || result)
  if (result[currentEnv] && Object.prototype.toString.call(result[currentEnv]).slice(8, -1) === 'Object') {
    return result[currentEnv]
  }
  return result
}
export default install()